import { CPHeader } from "../../assets";
import { Card } from "../molecules";
import { From } from "../molecules/Card/Card";
import "../../resources/login.scss";
import { Form } from "../organisms";
import { Link, useNavigate } from "react-router-dom";
import { Button, ButtonHtmlType, ButtonType, Input } from "../atoms";
import { useCallback, useEffect, useState } from "react";
import { LoginType, ROUTES } from "../../constants";
import { post } from "../../utils/request";
import { api, STATUS } from "../../constants/api";
import { message } from "antd";
import { useDispatch } from "react-redux";
import { setToken, setUserId } from "../../store/slices/user";
import { isTokenValid } from "../../utils/token";

export const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onClickLogin = useCallback(
    async (values: LoginType) => {
      setIsLoading(true);
      const errorMessage =
        "API or Database Unavailable. Please try again later or refresh and retry again!";

      try {
        const res = await post(api.login, values);
        if (res?.status === STATUS.SUCCESS && res?.data?.token) {
          localStorage.setItem("token", res.data.token);
          localStorage.setItem("userId", res.data.userId);
          dispatch(setToken(res.data?.token));
          dispatch(setUserId(res.data?.userId));
          navigate("/");
          return;
        }

        message.error(res?.data || errorMessage);
      } catch {
        message.error(errorMessage);
      }
      setIsLoading(false);
    },
    [navigate, dispatch],
  );

  useEffect(() => {
    const token: string | null = localStorage.getItem("token");
    const isValidToken = isTokenValid(token);
    if (isValidToken) {
      navigate("/");
    }
  }, [navigate]);

  return (
    <div className="cp-login-page">
      <div className="cp-login-page__container cp--flex-center">
        <div className="cp-login-page__container__header cp--flex-center">
          <img src={CPHeader} alt="cp-header-image" />
        </div>

        <div className="cp-login-page__container__welcome cp--flex-center">
          <h1>Welcome Back!</h1>
          <h2>Please sign in to continue managing your finances</h2>
        </div>

        <div className="cp-login-page__container__card">
          <Card from={From.LOGIN}>
            <Form onSubmitForm={onClickLogin}>
              <Input
                placeholder="Email"
                name="email"
                isRequired={true}
                requiredMessage="This field is required!"
                isEmail={true}
              />
              <Input
                placeholder="Password"
                name="password"
                isRequired={true}
                requiredMessage="This field is required!"
                isPassword={true}
              />
              <div className="cp-login-page__container__button cp--flex-center">
                <Button
                  isLoading={isLoading}
                  text="LOG IN"
                  htmlType={ButtonHtmlType.SUBMIT}
                  type={ButtonType.PRIMARY}
                />
              </div>
              <div className="cp-login-page__container__sign-up cp--flex-center">
                Don't have an account?{" "}
                <Link to={ROUTES.SIGN_UP}>
                  <u>Sign Up</u>
                </Link>
              </div>
            </Form>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Login;
